
import { v4 as uuidv4 } from 'uuid'

import { EntityId } from '@reduxjs/toolkit'

import { PlanningShift } from '../models/planning/PlanningShift'
import { PlanningStop } from '../models/planning/PlanningStop'
import { Scenario } from '../models/planning/Scenario'
import { LoadIndicatorStop } from '../models/Stop'
import { StopTypeEnum } from '../models/StopType'

export type GetPlanningShiftsStopsReturnType = {
  stops: PlanningStop[]
  shifts: PlanningShift[]
}

export const getShiftsStopsFromScenarios = (scenarios: Scenario[]): GetPlanningShiftsStopsReturnType => {
  const shifts = scenarios.flatMap(scenario => scenario.shifts)
  const allStops: PlanningStop[] = []

  shifts.forEach((shift) => {
    const shiftId = shift.id
    const numLoads = shift.loads.length
    const displaySequence = 0

    // Keep track of entities id for fast retrival later on
    const orderIds: EntityId[] = []
    const shiftStopIds: EntityId[] = []

    shift.start.displaySequence = displaySequence
    allStops.push(shift.start)
    shiftStopIds.push(shift.start.id)

    for (let i = 0; i < shift.loads.length; i++) {
      const load = shift.loads[i]
      let lastSequenceNumber = 0

      for (let j = 0; j < load.stops.length; j++) {
        const stop = load.stops[j]

        if (stop.stopType === StopTypeEnum.Order) {
          orderIds.push(stop.orderId)
        }

        allStops.push(stop)
        shiftStopIds.push(stop.id)

        lastSequenceNumber = stop.sequence
      }

      if (numLoads > 1) {
        // Because the server is returning a nested structure,
        //   we have to deserialize the load as one of the stop's separator
        const loadIndicatorStop: LoadIndicatorStop = {
          id: uuidv4(),
          shiftId: shiftId,
          stopType: StopTypeEnum.LoadIndicator,
          sequence: lastSequenceNumber + 5,
          isUnderUtilized: load.isUnderUtilized,
          orderCount: load.orderCount,
          totalDistance: load.totalDistance,
          totalTravelTime: load.totalTravelTime,
          totalVolume: load.totalVolume,
          totalWeight: load.totalWeight,
          totalQuantity: load.totalQuantity,
          maxVolume: load.maxVolume,
          maxWeight: load.maxWeight,
          totalWorkingTime: load.totalWorkingTime,
          violationCount: load.violationCount,
          violations: load.violations,
          isJob: false,
          loadNumber: i + 1,
        }

        allStops.push(loadIndicatorStop)
        shiftStopIds.push(loadIndicatorStop.id)
      }
    }

    allStops.push(shift.finish)
    shiftStopIds.push(shift.finish.id)

    shift.driverUserId = shift?.driverUserId
    shift.stopIds = shiftStopIds
    shift.orderIds = orderIds
  })

  return {
    stops: allStops,
    shifts,
  }
}